import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';

import { provideFirebaseApp, initializeApp, FirebaseApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideFunctions, getFunctions } from '@angular/fire/functions';
import { provideIonicAngular } from '@ionic/angular/standalone';

import { environment } from './environments/environment';
import { Injector } from '@angular/core'; // <--- ADD THIS IMPORT

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideIonicAngular(),

    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),

    // 🔥 Bind Functions to the SAME Firebase App instance
    provideFunctions((injector: Injector) => { // <--- CHANGE parameter from 'app: FirebaseApp' to 'injector: Injector'
      const app = injector.get(FirebaseApp);  // <--- ADD THIS LINE to get FirebaseApp from the injector
      return getFunctions(app, 'europe-west1');
    })
  ]
});
